import { Banner as BannerComponent } from 'components/banner';
import styled from 'styled-components';

const Banner = styled(BannerComponent)`
    align-items: flex-start;
    border-radius: 0;
`;

export { Banner };
